import { j as e } from "../../jsx-runtime.BREq8dyb.js";
import { styled as r, Stack as h, Sheet as u, useThemeProps as S } from "@mui/joy";
import { L as f } from "../../input-otp.BCFQUWVj.js";
import { memo as x } from "react";
const o = "DqOtpInput", j = r(h, {
  name: o,
  slot: "stack"
})(), k = r(u, {
  name: o,
  slot: "sheet"
})(({
  ownerState: {
    isActive: t
  } = {},
  theme: {
    radius: s
  }
}) => ({
  alignItems: "center",
  borderRadius: s.sm,
  display: "flex",
  fontSize: "1.5rem",
  height: "2.75rem",
  justifyContent: "center",
  width: "2.25rem",
  ...t && {
    borderWidth: 0,
    boxShadow: "inset 0 0 0 calc(var(--joy-focus-thickness)) var(--FormHelperText-color, var(--joy-palette-focusVisible))"
  }
})), y = x((t) => {
  const {
    id: s,
    slotProps: n,
    ...p
  } = S({
    name: o,
    props: t
  }), {
    stack: a,
    sheet: i
  } = n || {};
  return /* @__PURE__ */ e.jsx(f, { render: ({
    slots: c
  }) => /* @__PURE__ */ e.jsx(j, { direction: "row", spacing: 2, ...a, children: c.map(({
    isActive: l,
    char: m
  }, d) => /* @__PURE__ */ e.jsx(k, { ownerState: {
    isActive: l
  }, variant: "outlined", ...i, children: m }, d)) }), ...p });
});
y.displayName = "DqOtpInput";
export {
  y as default
};
//# sourceMappingURL=DqOtpInput.js.map
